const productHeroContainer = {
  padding: { xs: '4rem 1rem 0 1rem', ipad: '6rem 2rem 0 2rem' },
  borderRadius: '0 0 2rem 2rem',
  width: '100%',
  background: 'linear-gradient(to bottom, #18284D 0%, #000 100%)',
};

const heroContentStack = {
  display: 'flex',
  flexDirection: { xs: 'column', lg: 'row' },
  padding: { xs: '2rem 1rem 0 1rem', lg: '3rem 3rem 0 3rem' },
  justifyContent: 'space-between',
  alignItems: 'center',
  maxWidth: '80rem',
  width: '100%',
};

const textContentStack = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', desktop: 'flex-start' },
  gap: '2.5rem',
  width: '80%',
};

const headerStack = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: { xs: 'center', desktop: 'flex-start' },
  gap: '1rem',
  alignSelf: 'stretch',
  width: { xs: '100%', lg: '90%' },
};

const informationStackStyles = {
  padding: '0.5rem 1rem',
  borderRadius: '6.25rem',
  border: '1px solid white',
};

const titleContainer = {
  width: '100%',
  gap: '0.5rem',
  alignItems: { xs: 'center', desktop: 'flex-start' },
};

const titleTypography = {
  color: 'white',
  fontSize: { xs: '2rem', phone: '2.5rem', md: '3rem' },
  textAlign: { xs: 'center', desktop: 'left' },
  overflowWrap: { xs: 'anywhere', ipad: 'normal' },
  wordBreak: { xs: 'break-word', ipad: 'normal' },
  hyphens: { xs: 'auto', ipad: 'none' },
};

const subtitleTypography = {
  color: 'white',
  fontWeight: 500,
  textAlign: { xs: 'center', desktop: 'left' },
};

const registerButton = {
  height: '3rem',
  padding: '0.75rem 1.5rem',
  gap: '0.5rem',
  marginBottom: '3rem',
};

const imageContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignSelf: { xs: 'center', lg: 'flex-end' },
  overflow: 'hidden',
};

const normalImageContainer = {
  ...imageContainer,
  width: { xs: '100%', sm: '35rem', m: '40rem' },
};

const smallImageContainer = {
  ...imageContainer,
  width: { xs: '100%', sm: '35rem', md: '50rem' },
  transform: { xs: 'none', lg: 'translateX(10%) translateY(-10%)' },
};

const imageStyles = {
  objectFit: 'cover',
  width: '100%',
};

export {
  productHeroContainer,
  heroContentStack,
  textContentStack,
  headerStack,
  informationStackStyles,
  titleContainer,
  titleTypography,
  subtitleTypography,
  registerButton,
  normalImageContainer,
  smallImageContainer,
  imageStyles,
};
